module.exports = __webpack_public_path__ + "static/media/logo-inverted.4fbbf2a5.svg";